/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ leftChain: NonNullable<unknown>, rightChain: NonNullable<unknown>, metric: NonNullable<unknown> }} Chain_Page_Compare_Total_Txns_No_BothInputs */



/**
* | output |
* | --- |
* | "Neither {leftChain} nor {rightChain} have data for {metric}" |
*
* @param {Chain_Page_Compare_Total_Txns_No_BothInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const chain_page_compare_total_txns_no_both = /** @type {((inputs: Chain_Page_Compare_Total_Txns_No_BothInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chain_Page_Compare_Total_Txns_No_BothInputs, { locale?: "en" }, {}>} */ ((i, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ (`Neither ${i?.leftChain} nor ${i?.rightChain} have data for ${i?.metric}`)
});